import { Image } from '@accedo/ctv-image';
import { stylesheet } from 'astroturf';
import { FunctionalComponent } from 'preact';
import { FeaturedShowItem } from './types';

const TILE_WIDTH_PX = 225;

const styles = stylesheet`
  @import '##/styles/import.scss';

  .carousel-item {
    position: relative;
    width: pxToVw(${TILE_WIDTH_PX});
    height: pxToVh(200);
    margin-right: pxToVw(20);
    font-family: barlow;
    flex-shrink: 0;

    &:global(.current-focus) .image {
        border-radius: 2px;
        transform: scale(1.1, 1.1);
        box-shadow: 0 0 0 2px $pure-white;
    }

    .card-title {
        margin-top: pxToVh(10);
        font-size: 1.64rem;
        line-height: pxToVh(20);
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        height: pxToVh(22);
        overflow: hidden;
    }

    .card-subtitle {
        font-size: 1.35rem;
        margin-top: pxToVh(6);
        opacity: 1;
        color: $secondary-grey;
        line-height: pxToVh(17);
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        height: pxToVh(17.5);
        overflow: hidden;
    }
  }
`;

export const FeaturedShowTile: FunctionalComponent<FeaturedShowItem & {
  isInbound?: boolean;
  domId: string;
  description: string;
}> = (props) => {
  if (props.isInbound === false) {
    return <div id={props.domId} className={styles.carouselItem} />;
  }
  const fallbackUrl = '/assets/placeholders/Fallback-Thumbnail-Landscape.jpg';
  const heightGivenWidth = (width: number): number =>
    Math.floor((width * 720) / 1280);
  return (
    <div className={styles.carouselItem} id={props.domId}>
      <Image
        className={styles.image}
        url={`${props.imageUrl}?image-profile=foxtel_landscape`}
        fallbackUrl={fallbackUrl}
        width={TILE_WIDTH_PX}
        height={heightGivenWidth(TILE_WIDTH_PX)}
      />
      {props.title && <div className={styles.cardTitle}>{props.title}</div>}
      {props.description && (
        <div className={styles.cardSubtitle}>{props.description}</div>
      )}
    </div>
  );
};
